import { atom } from 'jotai';

import {
  approvalRespondAtom,
  pendingApprovalsListQueryAtom,
  ApprovalStatus,
  ApprovalSortOption,
} from '../_graphql/approvalRequests';

import { atomFromQueryString } from '~/shared/state/location.state';

// Query String Parameters
export const $searchTerm = atomFromQueryString.string('q');
export const $selectedStatus =
  atomFromQueryString.string<ApprovalStatus>('status');
export const $selectedAutomationId = atomFromQueryString.string('automationId');
export const $sortOption = atomFromQueryString.string<ApprovalSortOption>(
  'sort',
  'RequestedAtDesc',
);
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

// Selected Approval for Detail Dialog
export const $selectedApprovalId = atom<string | null>(null);

// Computed Data - Query Params
export const $approvalsListParams = atom((get) => {
  const selectedStatus = get($selectedStatus);
  const selectedAutomationId = get($selectedAutomationId);
  const sortOption = get($sortOption);
  const limit = get($limit);
  const offset = get($offset);

  const params: {
    status?: ApprovalStatus[];
    automationId?: string;
    sorting?: ApprovalSortOption[];
    limit: number;
    offset: number;
  } = {
    limit,
    offset,
  };

  if (selectedStatus) params.status = [selectedStatus];
  if (selectedAutomationId) params.automationId = selectedAutomationId;
  if (sortOption) params.sorting = [sortOption];

  return params;
});

// Remote Data
export const $remoteApprovals = pendingApprovalsListQueryAtom((get) => ({
  variables: get($approvalsListParams),
}));

// Pagination Helpers (computed from query string params)
export const $currentPage = atom((get) => {
  const offset = get($offset);
  const limit = get($limit);
  return Math.floor(offset / limit) + 1;
});

export const $totalPages = atom((get) => {
  const data = get($remoteApprovals).data;
  const limit = get($limit);
  const total = data?.total ?? 0;
  return Math.ceil(total / limit);
});

// Actions
export const $respondToApproval = approvalRespondAtom({
  onSuccess: (get) => {
    get($remoteApprovals).refetch?.();
  },
});
